import styled from '@emotion/styled';
import Slider, { sliderClasses } from '@mui/material/Slider';

import { PaletteColor } from '../../styling/AppStyles';

/**
 * A MUI <Slider> with custom styles
 */
const ExinMuiSlider = styled(Slider)`
  padding: 10px 0px;

  .${sliderClasses.track} {
    color: ${PaletteColor.bright};
  }
  .${sliderClasses.rail} {
    color: ${PaletteColor.white};
  }
  .${sliderClasses.thumb} {
    color: ${PaletteColor.text};
  }
`;

export default ExinMuiSlider;
